import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Logo from "@/components/Logo";
import { business } from "@/data/content";

export default function Footer() {
  return (
    <footer className="navy-gradient text-white pt-20 pb-36 lg:pb-14" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Logo variant="light" />
            <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-xs">
              Complete water care for Sunshine Coast homes — tank cleaning, filtration, UV,
              testing and system servicing.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.16em] text-pristine-aquamid mb-5">Contact</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href={business.phoneHref} className="inline-flex items-center gap-2 hover:text-white"><Phone className="h-4 w-4" /> {business.phone}</a></li>
              <li><a href={`mailto:${business.email}`} className="inline-flex items-center gap-2 hover:text-white break-all"><Mail className="h-4 w-4 shrink-0" /> {business.email}</a></li>
              <li className="inline-flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0" /> {business.address}</li>
              <li className="inline-flex items-center gap-2"><Clock className="h-4 w-4" /> {business.hours}</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.16em] text-pristine-aquamid mb-5">Services</h4>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li><a href="#services" className="hover:text-white">Tank Cleaning</a></li>
              <li><a href="#services" className="hover:text-white">Water Filtration</a></li>
              <li><a href="#services" className="hover:text-white">UV Disinfection</a></li>
              <li><a href="#services" className="hover:text-white">Water Testing</a></li>
              <li><a href="#services" className="hover:text-white">Bore Water Treatment</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.16em] text-pristine-aquamid mb-5">Explore</h4>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li><a href="#why" className="hover:text-white">Why Pristine</a></li>
              <li><a href="#area" className="hover:text-white">Service Area</a></li>
              <li><a href="#faq" className="hover:text-white">FAQs</a></li>
              <li><a href="#contact" className="hover:text-white">Request a Quote</a></li>
              <li><a href="/admin" className="hover:text-white text-white/40">Admin</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Pristine Water Systems Sunshine Coast. All rights reserved.</p>
          <p>Locally operated across Noosa, Maroochydore & the Sunshine Coast.</p>
        </div>
      </div>
    </footer>
  );
}
